// ======================================================================
// Google Map block | info@visualdialogue.com
// ======================================================================

// window.$ = window.jQuery = require('jquery');

// ======================================================================
// Modules
// ======================================================================

// import { MarkerWithLabel } from '@googlemaps/markerwithlabel';
// import { Loader } from '@googlemaps/js-api-loader';

// require any further scripts here ie:
// require('npmpackagename');
// require('./mylocalfile.js');

// maps
site.icons = []; // save for clustering
site.markers = []; // save for clustering
site.labels = []; // save for clustering
site.logos = []; // save for clustering
site.tstations = []; // save for clustering
site.colors = {
  blueline: "#003da5",
  greenline: "#00843d",
  redline: "#da291c",
  orangeline: "#ed8b00",
  bus: "#ffc72c",
  lightgray: "#888b8c",
  palette: {
    purple: "#4d4f96",
    blue: "#249fda",
    red: "#ee2e24",
    green: "#2bb673",
    teal: "#88d1d1",
    orange: "#f15a31",
    gold: "#ffd620",
    pink: "#f17db1",
  },
};

// google map as object literal
// from https://stackoverflow.com/a/40642485
// inspired by http://rmurphey.com/blog/2009/10/15/using-objects-to-organize-your-code

map = {
  config: {
    colors: {
      // overallMap: site.colors.palette.teal,
      // water: site.colors.palette.blue,
      // secondaryRoads: "#bfe6eb",
      // interstateMainRoads: "#a8c7cc",
      // // parksReservations: '#b0d1d6',
      // parksReservations: site.colors.palette.l_green,
      // secondaryAreas: "#b7d8df",
    },
    logos: {
      "The BA": {
        icon: "assets/svg/the-ba_placeholder-icon_03.08.23.svg",
        size: 70,
        coordinates: {
          lat: 42.3257,
          lng: -71.1525,
        },
      },
    },
    icons: {
      // "I-495": {
      //   icon: "/assets/svg/map/495-simplified.svg",
      //   size: 40,
      //   coordinates: {
      //     lat: 42.0855,
      //     lng: -71.4239,
      //   },
      // },
      TMC: {
        // icon: "/assets/svg/map/tmc-logo_inverted.png",
        icon: "assets/svg/map/tmc-logo.png",
        size: 60,
        coordinates: {
          lat: 42.344458,
          lng: -71.084986,
        },
      },
    },
    logoMarkers: {},
    markers: {},
    styles: {
      // all pois in https://developers.google.com/maps/documentation/javascript/style-reference
      default: [
        {
          featureType: "poi",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },

        {
          featureType: "administrative.land_parcel",
          elementType: "all",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "administrative.locality",
          elementType: "labels",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "administrative.neighborhood",
          elementType: "labels",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "administrative.province",
          elementType: "labels",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "landscape",
          elementType: "labels",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "landscape.man_made",
          elementType: "geometry",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "water",
          elementType: "labels",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "road.local",
          elementType: "labels",
          stylers: [
            {
              visibility: "on",
            },
          ],
        },
      ],
      vd: [
        {
          featureType: "all",
          elementType: "labels",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "all",
          elementType: "labels.text.fill",
          stylers: [
            {
              saturation: 36,
            },
            {
              color: "#333333",
            },
            {
              lightness: 40,
            },
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "all",
          elementType: "labels.text.stroke",
          stylers: [
            {
              visibility: "off",
            },
            {
              color: "#ffffff",
            },
            {
              lightness: 16,
            },
          ],
        },
        {
          featureType: "all",
          elementType: "labels.icon",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "administrative",
          elementType: "geometry.fill",
          stylers: [
            {
              color: "#fefefe",
            },
            {
              lightness: 20,
            },
          ],
        },
        {
          featureType: "administrative",
          elementType: "geometry.stroke",
          stylers: [
            {
              color: "#fefefe",
            },
            {
              lightness: 17,
            },
            {
              weight: 1.2,
            },
          ],
        },
        {
          featureType: "landscape",
          elementType: "geometry",
          stylers: [
            {
              color: "#f1f1f1",
            },
            {
              lightness: 20,
            },
          ],
        },
        {
          featureType: "poi",
          elementType: "geometry",
          stylers: [
            {
              color: "#f5f5f5",
            },
            {
              lightness: 21,
            },
          ],
        },
        {
          featureType: "poi.park",
          elementType: "geometry",
          stylers: [
            {
              color: "#e5e5e5",
            },
            {
              lightness: 21,
            },
          ],
        },
        {
          featureType: "road.highway",
          elementType: "geometry.fill",
          stylers: [
            {
              color: "#ffffff",
            },
            {
              lightness: 17,
            },
          ],
        },
        {
          featureType: "road.highway",
          elementType: "geometry.stroke",
          stylers: [
            {
              color: "#ffffff",
            },
            {
              lightness: 29,
            },
            {
              weight: 0.2,
            },
          ],
        },
        {
          featureType: "road.arterial",
          elementType: "geometry",
          stylers: [
            {
              color: "#ffffff",
            },
            {
              lightness: 18,
            },
          ],
        },
        {
          featureType: "road.local",
          elementType: "geometry",
          stylers: [
            {
              color: "#ffffff",
            },
            {
              lightness: 16,
            },
            {
              visibility: "off",
            },
          ],
        },
        // {
        //   featureType: "transit",
        //   elementType: "geometry",
        //   stylers: [
        //     {
        //       color: "#f2f2f2",
        //     },
        //     {
        //       lightness: 19,
        //     },
        //   ],
        // },
        {
          featureType: "water",
          elementType: "geometry",
          stylers: [
            {
              color: "#d5d5d5",
            },
            {
              lightness: 17,
            },
          ],
        },
      ],
      ba: [
        {
          featureType: "administrative",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#686868",
            },
          ],
        },
        {
          featureType: "landscape",
          elementType: "all",
          stylers: [
            {
              color: "#F2F2F2",
            },
          ],
        },
        {
          featureType: "landscape",
          elementType: "geometry.fill",
          stylers: [
            {
              color: "#FEFCF5",
            },
          ],
        },
        // {
        //   featureType: "administrative.land_parcel",
        //   elementType: "all",
        //   stylers: [
        //     {
        //       visibility: "off",
        //     },
        //   ],
        // },
        {
          featureType: "administrative.locality",
          elementType: "labels",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        // {
        //   featureType: "administrative.neighborhood",
        //   elementType: "labels",
        //   stylers: [
        //     {
        //       visibility: "off",
        //     },
        //   ],
        // },
        {
          featureType: "administrative.province",
          elementType: "labels",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "poi",
          elementType: "all",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "road",
          elementType: "all",
          stylers: [
            {
              saturation: -100,
            },
            {
              lightness: 45,
            },
          ],
        },
        {
          featureType: "road",
          elementType: "geometry.fill",
          stylers: [
            {
              color: "#EFEBE5",
            },
            {
              lightness: "0",
            },
            {
              gamma: "1.00",
            },
          ],
        },
        {
          featureType: "road",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#FFFFFF",
            },
            {
              visibility: "on",
            },
            {
              lightness: "70",
            },
          ],
        },
        {
          featureType: "road.highway",
          elementType: "all",
          stylers: [
            {
              visibility: "off",
            },
            {
              color: "#BFB7AE",
            },
            {
              lightness: "75",
            },
            {
              gamma: "1",
            },
          ],
        },
        {
          featureType: "road.highway",
          elementType: "geometry.fill",
          stylers: [
            {
              lightness: "0",
            },
            {
              visibility: "on",
            },
            {
              color: "#EFEBE5",
            },
            {
              gamma: "1",
            },
          ],
        },
        {
          featureType: "road.highway",
          elementType: "geometry.stroke",
          stylers: [
            {
              saturation: "11",
            },
            {
              lightness: "-51",
            },
            {
              visibility: "off",
            },
            {
              color: "#FF0000",
            },
          ],
        },
        {
          featureType: "road.highway",
          elementType: "labels.text",
          stylers: [
            {
              saturation: "3",
            },
            {
              lightness: "-56",
            },
            {
              weight: "2.20",
            },
          ],
        },
        {
          featureType: "road.highway",
          elementType: "labels.text.fill",
          stylers: [
            {
              lightness: "-52",
            },
          ],
        },
        {
          featureType: "road.highway",
          elementType: "labels.text.stroke",
          stylers: [
            {
              weight: "6.13",
            },
          ],
        },
        {
          featureType: "road.highway",
          elementType: "labels.icon",
          stylers: [
            {
              lightness: "-10",
            },
            {
              gamma: "0.94",
            },
            {
              weight: "1.24",
            },
            {
              saturation: "-100",
            },
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "road.arterial",
          elementType: "geometry",
          stylers: [
            {
              lightness: "0",
            },
            {
              color: "#EFEBE5",
            },
            {
              gamma: "1.00",
            },
          ],
        },
        {
          featureType: "road.arterial",
          elementType: "labels.text.fill",
          stylers: [
            {
              saturation: "-41",
            },
            {
              lightness: "-41",
            },
          ],
        },
        {
          featureType: "road.arterial",
          elementType: "labels.text.stroke",
          stylers: [
            {
              weight: "5.46",
            },
          ],
        },
        {
          featureType: "road.arterial",
          elementType: "labels.icon",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "road.local",
          elementType: "geometry",
          stylers: [
            {
              color: "#EFEBE5",
            },
            {
              lightness: "0",
            },
            {
              gamma: "1",
            },
          ],
        },
        {
          featureType: "road.local",
          elementType: "geometry.fill",
          stylers: [
            {
              weight: "0.72",
            },
            {
              lightness: "-16",
            },
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "road.local",
          elementType: "labels.text.fill",
          stylers: [
            {
              lightness: "-37",
            },
          ],
        },
        {
          featureType: "transit",
          elementType: "all",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        // {
        //   featureType: "transit.station.rail",
        //   elementType: "labels",
        //   stylers: [
        //     {
        //       visibility: "simplified",
        //     },
        //   ],
        // },
        // {
        //   featureType: "transit.station.rail",
        //   elementType: "labels.text",
        //   stylers: [
        //     {
        //       color: "#757575",
        //     },
        //   ],
        // },
        {
          featureType: "water",
          elementType: "all",
          stylers: [
            {
              color: "#D4EFFC",
            },
            {
              visibility: "on",
            },
          ],
        },
        {
          featureType: "water",
          elementType: "labels",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
      ],
    },
    locations: {
      center: {
        lat: 42.337,
        lng: -71.11,
      },
      mobileCenter: {
        // lat: 42.3251219,
        // lng: -71.1533625,
        lat: 42.337,
        lng: -71.11,
      },
    },
    labels: {
      // 'The Curtis Apartments': {
      //   lat: 42.0815477,
      //   lng: -71.460223
      // }
    },
    labelMarkers: {},
    tstations: {
      // "Forge Park/495 MBTA Station": {
      //   level: 1,
      //   offsetTop: 15,
      //   coordinates: {
      //     lat: 42.08995,
      //     lng: -71.4392,
      //   },
      // },
    },
    iconPath: "assets/svg/",
    nearbyType: null,
    // init here for scope reasons, https://stackoverflow.com/q/16912892/4504073
    labelOrigin: null,
    infoWindow: null,
    popup: null,
    service: null,
    // transit layer, from https://developers.google.com/maps/documentation/javascript/examples/layer-transit
    transitLayer: null,

    // zoom levels
    mobileZoomLevel: 12,
    // tabletZoomLevel: 14,
    tabletZoomLevel: 13,
    desktopZoomLevel: 14,
    // desktopZoomLevel: 13,
    massiveZoomLevel: 14,
    // massiveZoomLevel: 13,

    transportation: null, // init global so when call results from google cache file, can send to another function
    tMarker: null,
    trails: {},

    // labels
    textColorDefault: "#FF0000",
    textColorDefault: "#006191",
    labelFontSize: "16px",
  },

  /**
   * run these on initial map startup
   **/
  init: function () {
    console.log("map.init");

    // check for mobile on init
    if (site.isMobile) {
      map.config.initialMapCenter = map.config.locations.mobileCenter;
    } else {
      map.config.initialMapCenter = map.config.locations.center;
    }

    // console.log('map.config.initialMapCenter', map.config.initialMapCenter);

    let initialMapZoomLevel;
    if (site.isMobile) {
      initialMapZoomLevel = map.config.mobileZoomLevel;
    } else if (site.isTablet) {
      initialMapZoomLevel = map.config.tabletZoomLevel;
    } else if (site.isDesktop) {
      initialMapZoomLevel = map.config.desktopZoomLevel;
    } else {
      initialMapZoomLevel = map.config.massiveZoomLevel;
    }

    googleMap = new google.maps.Map(document.getElementById("google-map"), {
      // mapId: "1ceb776683916c8d",
      center: map.config.initialMapCenter,
      zoom: initialMapZoomLevel,
      fullscreenControl: false, // turn off full screen button
      mapTypeControl: false,
      styles: map.config.styles["ba"],
      markers: [],
      keyboardShortcuts: false,
    });

    // map.showPlaces(googleMap); // set on map

    /**
     * logos
     **/
    // loop through json, from https://stackoverflow.com/a/5737136/4504073
    Object.keys(map.config.logos).forEach(function (key) {
      map.config.logoMarkers[key] = {};

      let size = map.config.logos[key].size;

      let marker = new google.maps.Marker({
        map: googleMap,
        position: map.config.logos[key].coordinates,
        icon: {
          url: map.config.logos[key].icon,
          size: new google.maps.Size(size, size),
          scaledSize: new google.maps.Size(size, size),
          anchor: new google.maps.Point(size / 2, size / 4),
        },
        label: "",
        zIndex: 100, // above markers

        // visible: false, // hide on init in case mobile
      });

      // for use in hiding/showing labels
      site.logos.push({
        marker: marker, // save to change size
      });
    });

    /**
     * icons
     **/
    Object.keys(map.config.icons).forEach(function (key) {
      map.config.logoMarkers[key] = {};

      // logo icon
      let icon = "/assets/svg/map/curtis-map-logo.svg";

      let size = map.config.icons[key].size;
      // let anchorX = map.config.icons[key].anchorX;
      // let anchorY = map.config.icons[key].anchorY;

      let marker = new google.maps.Marker({
        map: googleMap,
        position: map.config.icons[key].coordinates,
        icon: {
          url: map.config.icons[key].icon,
          size: new google.maps.Size(size, size),
          scaledSize: new google.maps.Size(size, size),
          anchor: new google.maps.Point(size / 2, size / 2),
        },
        label: "",
        zIndex: 100, // above markers

        // visible: false, // hide on init in case mobile
      });

      // for use in hiding/showing labels
      site.icons.push({
        marker: marker, // save to change size
      });
    });

    /**
     * labels
     **/
    // loop through json, from https://stackoverflow.com/a/5737136/4504073
    Object.keys(map.config.labels).forEach(function (key) {
      // determine label size
      let labelClass = "map-label";

      if (map.config.labels[key].level == 1) {
        labelClass = "map-large-label";
      }

      if (map.config.labels[key].class) {
        labelClass += " " + map.config.labels[key].class;
      }

      let marker = new google.maps.Marker({
        map: googleMap,
        position: map.config.labels[key].coordinates,
        icon: " ",
      });

      // use infowindow for multiline text
      let contentString =
        '<div class="' + labelClass + ' zoom-">' + key + "</div>";

      let infoWindow = new google.maps.InfoWindow({
        content: contentString,
        // pixelOffset: new google.maps.Size(0, map.config.labels[key].offsetTop),
        disableAutoPan: true,
      });

      infoWindow.open({
        anchor: marker,
        googleMap,
        shouldFocus: false,
      });

      // re-center after info windows are opened
      // googleMap.panTo(map.config.initialMapCenter);

      // for use in hiding/showing labels
      site.labels.push({
        marker: marker, // save to hide/show
        infoWindow: infoWindow, // save to change offset when zoom changes
      });
    });

    /**
     * t stations
     **/
    Object.keys(map.config.tstations).forEach(function (key) {
      // determine label size
      let labelClass = "map-label map-tstation";

      let marker = new google.maps.Marker({
        map: googleMap,
        position: map.config.tstations[key].coordinates,
        icon: {
          url: map.config.iconPath + "map/mbta-commuter-rail_2022.04.18.svg",
          scaledSize: new google.maps.Size(40, 40),
          anchor: new google.maps.Point(20, 40),
        },
        zIndex: 0, // below markers
      });

      // use infowindow for multiline text
      let contentString =
        '<div class="' + labelClass + ' zoom-">' + key + "</div>";

      let infoWindow = new google.maps.InfoWindow({
        content: contentString,
        pixelOffset: new google.maps.Size(
          0,
          map.config.tstations[key].offsetTop
        ),
        disableAutoPan: true,
      });

      infoWindow.open({
        anchor: marker,
        googleMap,
        shouldFocus: false,
      });

      // re-center after info windows are opened
      // googleMap.panTo(map.config.initialMapCenter);

      // for use in hiding/showing labels
      site.tstations.push({
        marker: marker, // save to hide/show
        infoWindow: infoWindow, // save to change offset when zoom changes
      });
    });

    // always check zoom
    googleMap.addListener("zoom_changed", function (e) {
      map.zoomChange(googleMap);
    });

    /*****
     * set up controls
     *****/
    let mapControls = document.querySelectorAll(".map-control");
    // let mapList = document.getElementById('style-map-control');

    // loop through all inputs/labels
    for (let i = mapControls.length - 1; i >= 0; i--) {
      console.log("will click a category button");
      // add click event listener to each
      mapControls[i].addEventListener("click", function () {
        console.log("clicked a category button");
        // map.centerAndZoom();

        // add class to parent, so other labels go gray
        // mapList.classList.add('activated');

        // map.clearMap();

        // map.showPlaces(this.id);
      });
    }
  },

  /*****
   * Map zoomchange
   * https://stackoverflow.com/a/28005383/4504073
   *****/
  zoomChange: function (thismap) {
    console.log("zoom:", thismap.getZoom());

    // zoom level 10
    if (thismap.getZoom() <= 10) {
      // map.updateMarkerSize(site.logos, null);
      // zoom level 11
    } else if (thismap.getZoom() <= 11) {
      map.updateMarkerSize(site.logos, 40, 2, 4);
      // zoom level 12
    } else if (thismap.getZoom() <= 12) {
      map.updateMarkerSize(site.logos, 50, 2, 4);
      // zoom level 13
    } else if (thismap.getZoom() <= 13) {
      map.setZoomClass(13, thismap);
      map.updateMarkerSize(site.logos, 60, 2, 4);
      // zoom level 14
    } else if (thismap.getZoom() <= 14) {
      map.setZoomClass(14, thismap);
      map.updateMarkerSize(site.logos, 70, 2, 4);
      // zoom level 15
    } else if (thismap.getZoom() <= 15) {
      map.updateMarkerSize(site.logos, 80, 2, 4);
      // zoom level 16
    } else if (thismap.getZoom() <= 16) {
      // zoom level 17
    } else if (thismap.getZoom() <= 17) {
      // zoom level 18
    } else if (thismap.getZoom() <= 18) {
      // if (site.isMobile) {
      //   map.updateMarkerStyles("30px", 0.9, thismap);
      // } else {
      //   map.updateMarkerStyles("42px", 1.5, thismap);
      // }
    } else if (thismap.getZoom() <= 19) {
      map.setZoomClass(19, thismap);
    }
  },

  /**
   * Get cached google map data
   * for each data type, just once
   * from https://gomakethings.com/ajax-and-apis-with-vanilla-javascript/
   **/
  showPlaces: function (thismap) {
    // Set up our HTTP request
    let xhr = new XMLHttpRequest();

    // Setup our listener to process completed requests
    xhr.onload = function () {
      // Process our return data
      if (xhr.status >= 200 && xhr.status < 300) {
        // What do when the request is successful
        // console.log('success!', xhr);
        map.config.members = JSON.parse(xhr.response);

        // console.log('map.config.members', map.config.members);
        let results = map.config.members.results;
        console.log("results", results);

        // create markers from the nearby query
        for (var i = 0; i < results.length; i++) {
          // console.log('i', i);
          map.createMarker(results[i], i + 1, thismap);
        }

        // check zoom change, initially
        map.zoomChange(thismap);
      }

      // Code that should run regardless of the request status
      // console.log('This always runs...');
    };

    // Create and send a GET request
    // The first argument is the post type (GET, POST, PUT, DELETE, etc.)
    // The second argument is the endpoint URL
    xhr.open("GET", "mapajax.json");
    xhr.send();
  },

  /**
   * Create marker, initially for nearby places search
   * from https://developers.google.com/maps/documentation/javascript/examples/place-search
   **/
  // allow random color, from https://stackoverflow.com/a/15106541/4504073
  randomColor: function (palette) {
    var keys = Object.keys(palette);
    return keys[(keys.length * Math.random()) << 0];
  },

  colorSelector: function (type) {
    // set color
    switch (type) {
      case "closed":
        return "lighter-gray";
        break;
      case "eat-drink":
        return "green";
        break; // leave in for defensive programming, from https://stackoverflow.com/a/1437492/4504073
      case "health-fitness":
        return "m-orange";
        break;
      case "restaurant":
        return "red";
        break;
      case "special-event":
        return "teal";
        break;
      case "services":
        return "pink";
        break;
      case "grocery":
        return "gold";
        break;
      case "other":
        return "purple";
        break;
      case "pharmacy":
        return "blue";
        break;
      default:
        // return 'green';
        return "gold";

      // need science and technology?
    }
  },

  /*
   * add popup label
   * from https://developers.google.com/maps/documentation/javascript/examples/overlay-popup
   * @param location
   * @param name
   * @param label offset from left
   * @param label offset from bottom
   */
  addMarkerLabel: function (place) {
    var popupDiv = document.createElement("div");
    popupDiv.classList.add("member-label");
    var text = document.createTextNode(place.name);
    popupDiv.appendChild(text);

    popup = new site.Popup(
      new google.maps.LatLng(place.geometry.location),
      // place.name
      popupDiv
    );
    popup.setMap(googleMap);
  },

  createMarker: function (place, number, thismap) {
    // get icon and label colors
    // let colors = map.getColors(place.persistence, place.closed);

    let colors = map.getColors(place.category);

    // console.log('colors', colors);

    // add marker
    let icon;
    if (site.isMobile) {
      icon = map.makeIcon(0.3, colors); // get icon with scale of .5, with fillColor
    } else {
      icon = map.makeIcon(0.5, colors); // get icon with scale of .5, with fillColor
    }

    // get label at right size
    let label;
    if (site.isMobile) {
      label = map.makeLabel(number.toString(), "29px", colors);
    } else {
      label = map.makeLabel(number.toString(), "14px", colors);
    }

    var marker = new google.maps.Marker({
      map: thismap,
      title: place.name,
      position: place.geometry.location,
      // clickable: false, // no cursor pointer
      icon: icon,
      // label: label,
      zIndex: 1, // on top of t stations
    });

    let infoWindow;

    if (!place.closed) {
      // determine label size
      let labelClass = "map-label ";

      if (place.isabove) {
        labelClass += "is-above";
      }

      // use infowindow for multiline text
      // zoom- class for hook for css control
      // hover- class for hook on hover override
      let contentString =
        '<div class="' + labelClass + ' zoom- hover-">' + place.name + "</div>";

      infoWindow = new google.maps.InfoWindow({
        content: contentString,
        // pixelOffset: offset, // px offset not responsive
        disableAutoPan: true,
        labelOrigin: new google.maps.Point(39, 39),
      });

      infoWindow.open({
        anchor: marker,
        thismap,
        shouldFocus: false,
      });

      // // for mobile
      // marker.addListener("click", () => {
      //
      //   // open this infowindow
      //   infoWindow.open({
      //     anchor: marker,
      //     thismap,
      //     shouldFocus: false,
      //   });
      //
      //   // close any non-persistent infowindows
      //   for (let i = 0; i < thismap.markers.length; i++) {
      //     // if not a persistent marker on mobile
      //     if(!thismap.markers[i].persistence || thismap.markers[i].closed) {
      //       thismap.markers[i].infoWindow.close();
      //     }
      //   }
      //
      //   // override hidden info window in case small or massive screens
      //   map.showHiddenPersistentInfoWindow(infoWindow, thismap);
      //
      // });

      // for massive screens
      marker.addListener("mouseover", () => {
        map.showHiddenPersistentInfoWindow(infoWindow, thismap);
      });

      // for massive screens
      marker.addListener("mouseout", () => {
        map.stopOverridingHiddenPersistentInfoWindows(thismap);
      });

      // primary infowindow
    } else {
      // determine label size
      let labelClass = "map-label map-primary-label";
      labelClass += " " + place.class + "-label";

      // use infowindow for multiline text
      let contentString =
        '<div class="' + labelClass + '">' + place.name + "</div>";

      infoWindow = new google.maps.InfoWindow({
        content: contentString,
        // pixelOffset: offset,
        disableAutoPan: true,
      });

      // // testing
      // infoWindow.open({
      //   anchor: marker,
      //   thismap,
      //   shouldFocus: false,
      // });

      // // for mobile
      // marker.addListener("click", () => {
      //
      //   // close all other small info windows
      //   for (let i = 0; i < thismap.markers.length; i++) {
      //     // if not a persistent marker
      //     if(!thismap.markers[i].persistence || thismap.markers[i].closed) {
      //       thismap.markers[i].infoWindow.close();
      //     }
      //   }
      //
      //   map.stopOverridingHiddenPersistentInfoWindows(thismap);
      //
      //   // open this infowindow
      //   infoWindow.open({
      //     anchor: marker,
      //     thismap,
      //     shouldFocus: false,
      //   });
      // });

      // show labels when mouse over
      marker.addListener("mouseover", () => {
        infoWindow.open({
          anchor: marker,
          thismap,
          shouldFocus: false,
        });

        map.stopOverridingHiddenPersistentInfoWindows(thismap);
      });

      // hide labels when mouse away
      marker.addListener("mouseout", () => {
        infoWindow.close();
      });
    }

    // save marker for reversal or clustering
    thismap.markers.push({
      marker: marker, // save to hide/show
      infoWindow: infoWindow, // save to change offset when zoom changes
      // offset: place.offsettop, // save for changing on zoomchange
      persistence: place.persistence, // save for icon color
      closed: place.closed, // save for icon color
      class: place.class, // some buildings have more offset than others
      category: place.category, // save for updating marker styles on zoom
    });
  },

  setTransitOnMap: function (map) {
    for (let i = 0; i < site.tstations.length; i++) {
      site.tstations[i].marker.setMap(map);
    }
  },

  hideTransit: function () {
    map.setTransitOnMap(null);
  },

  showTransit: function (thismap) {
    map.setTransitOnMap(thismap);
  },

  // Removes the markers from the map, but keeps them in the array.
  // from https://developers.google.com/maps/documentation/javascript/examples/marker-remove
  hideMarkers: function (thismap) {
    for (let i = 0; i < thismap.markers.length; i++) {
      thismap.markers[i].marker.setMap(null);
    }
  },

  // Shows any markers currently in the array.
  showMarkers: function (thismap) {
    for (let i = 0; i < thismap.markers.length; i++) {
      thismap.markers[i].marker.setMap(thismap);
    }
  },

  // show hidden persistent infowindow
  showHiddenPersistentInfoWindow: function (infoWindow, thismap) {
    // clear out any overrides first
    map.stopOverridingHiddenPersistentInfoWindows(thismap);

    // add class to override infowindows hidden with css
    // easier than opening persistent labels again
    let infoWindowContent = infoWindow.getContent();

    // set css to show info window
    let showInfoWindowContent = infoWindowContent;
    infoWindow.setContent(showInfoWindowContent);
  },

  // remove existing css overrides, to show persistent labels on mobile or massive screens
  stopOverridingHiddenPersistentInfoWindows: function (thismap) {
    for (let i = 0; i < thismap.markers.length; i++) {
      // only persistent markers
      if (thismap.markers[i].persistence && !thismap.markers[i].closed) {
        let infoWindowContent = thismap.markers[i].infoWindow.getContent();
        let showInfoWindowContent = infoWindowContent.replace(
          "hover-1",
          "hover-"
        );
        thismap.markers[i].infoWindow.setContent(showInfoWindowContent);
      }
    }
  },

  /*
   * change icon size
   */
  updateMarkerSize: function (markers, size, offsetX, offsetY) {
    if (size) {
      Object.keys(markers).forEach(function (key, index) {
        // make new bigger icon, based on existing icon
        let newIcon = {
          url: markers[key].marker.icon.url,
          size: new google.maps.Size(size, size),
          scaledSize: new google.maps.Size(size, size),
          anchor: new google.maps.Point(size / offsetX, size / offsetY),
        };

        // update real icon
        markers[key].marker.setIcon(newIcon);

        // add back to map in case hidden
        markers[key].marker.setMap(googleMap);
      });
    } else {
      for (let i = 0; i < markers.length; i++) {
        markers[i].marker.setMap(null);
      }
    }
  },

  /*
   * change marker styles
   * @param fontsize, marker size, map
   */
  // updateMarkerStyles: function(fontSize, markerSize, offsetRatio, thismap) {
  updateMarkerStyles: function (fontSize, markerSize, thismap) {
    // console.log('(thismap.markers)', thismap.markers)

    Object.keys(thismap.markers).forEach(function (key, index) {
      // have to resend colors even when just changing size??
      // console.log('thismap.markers[key]', thismap.markers[key]);
      let colors = map.getColors(thismap.markers[key].category);

      if (markerSize) {
        // change circle size
        let icon = map.makeIcon(markerSize, colors);
        thismap.markers[key].marker.setIcon(icon);
      }
    });
  },

  setZoomClass: function (zoomLevel, thismap) {
    // console.info('setZoomClass to ' + zoomLevel);

    // adjust small labels
    for (let i = 0; i < thismap.markers.length; i++) {
      let infoWindowContent = thismap.markers[i].infoWindow.getContent();

      // replace all zoom numbers with new ones
      // from https://bobbyhadz.com/blog/javascript-replace-all-numbers-in-string
      let newInfoWindowContent = infoWindowContent.replace(
        /zoom-([0-9])*/g,
        "zoom-" + zoomLevel
      );

      thismap.markers[i].infoWindow.setContent(newInfoWindowContent);
    }

    // adjust large labels
    for (let i = 0; i < site.labels.length; i++) {
      let infoWindowContent = site.labels[i].infoWindow.getContent();

      // replace all zoom numbers with new ones
      // from https://bobbyhadz.com/blog/javascript-replace-all-numbers-in-string
      let newInfoWindowContent = infoWindowContent.replace(
        /zoom-([0-9])*/g,
        "zoom-" + zoomLevel
      );

      site.labels[i].infoWindow.setContent(newInfoWindowContent);
    }

    // adjust t stations
    for (let i = 0; i < site.tstations.length; i++) {
      let infoWindowContent = site.tstations[i].infoWindow.getContent();

      // replace all zoom numbers with new ones
      // from https://bobbyhadz.com/blog/javascript-replace-all-numbers-in-string
      let newInfoWindowContent = infoWindowContent.replace(
        /zoom-([0-9])*/g,
        "zoom-" + zoomLevel
      );

      site.tstations[i].infoWindow.setContent(newInfoWindowContent);
    }
  },

  makeIcon: function (scale, colors) {
    // console.log('colors.fill', colors.fill);
    // colors.fill = '#ff0000';

    let icon = {
      path: "M 25, 50 a 25,25 0 1,1 50,0 a 25,25 0 1,1 -50,0",
      size: new google.maps.Size(40, 64),

      fillColor: colors.fill,
      fillOpacity: 1,
      strokeWeight: 0,
      rotation: 0,
      scale: scale, // .5,
      // size: new google.maps.Size(200, 200),
      // origin: new google.maps.Point(400, 10),
      // scaledSize: new google.maps.Size(200, 200),
      anchor: new google.maps.Point(50, 50),
      labelOrigin: new google.maps.Point(50, 50),
    };

    return icon;
  },

  getColors: function (category) {
    // console.log('category', category);

    let colors = {};
    // colors['label'] = "#000000";

    switch (category) {
      case "attractions-activities":
        colors["fill"] = "#0f6642";
        break;

      case "shopping":
        colors["fill"] = "#5ab2e5";
        break;

      case "restaurants":
        colors["fill"] = "#a84836";
        break;

      case "banks":
        colors["fill"] = "#004a9c";
        break;

      default:
        colors["fill"] = "#666666";
    }

    // let colors = {};
    //
    // if (closed) {
    //   colors['fill'] = "#666666";
    //   colors['label'] = "#000000";
    // } else if(persistence) {
    //   colors['fill'] = "#f508a1";
    //   colors['label'] = "#ffffff";
    // } else {
    //   colors['fill'] = "#a84836";
    //   colors['label'] = "#ffffff";
    // }

    return colors;
  },

  makeLabel: function (number, size, colors) {
    let label = {
      text: number,
      // fontFamily: "input-sans-compressed",
      fontFamily: "input-mono",
      fontWeight: "bold",
      // fontWeight: "regular",
      // fontWeight: "black",
      color: colors.label,
      fontSize: size,
    };

    return label;
  },
};
